export default "__VITE_ASSET__DPHQ2hgW__"